<template>
  <div id="userLayout" :class="['user-layout-wrapper', device]">
    <div class="container">
      <div class="top">
        <div class="header">
          <img src="~@/assets/logo1.png" style="float:left;" width="60px;">
          <span style='line-height: 60px; text-align: center; color: rgb(78, 78, 78); font-size: 30px; font-family: "Microsoft YaHei";'>福州市电子招投标交易系统</span>
        </div>
<!--        <div class="desc">
          电子招投标是以数据电文形式完成的招标投标活动
        </div>-->
      </div>

      <route-view></route-view>

      <div class="footer" v-show="true">
        <div class="copyright">
          Copyright &copy; 2023 Fuzhou Public Resource Trading Service Center &nbsp;版权所有&nbsp;&nbsp;&nbsp;推荐使用<a href="https://www.google.cn/chrome/" target="_blank">Chrome浏览器</a>进行操作浏览
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import RouteView from "@/components/layouts/RouteView"
  import { mixinDevice } from '@/utils/mixin.js'

  export default {
    name: "UserLayout",
    components: { RouteView },
    mixins: [mixinDevice],
    data () {
      return {}
    },
    mounted () {
      document.body.classList.add('userLayout')
    },
    beforeDestroy () {
      document.body.classList.remove('userLayout')
    },
  }
</script>

<style lang="less" scoped>
  #userLayout.user-layout-wrapper {
    height: 100%;

    &.mobile {
      .container {
        .main {
          max-width: 368px;
          width: 98%;
        }
      }
    }

    .container {
      width: 100%;
      min-height: 100%;
      background: url(~@/assets/background.png);
      background-size: 100% 100%;
      /*padding: 60px 0 144px;*/
      position: relative;

      a {
        text-decoration: none;
      }

      .top {
        width:100%;
        text-align: left;
        margin: auto;
        background-color: #F0F2F5;

        .header {
          height: 60px;
          line-height: 60px;
          width:90%;
          margin: auto;

          .badge {
            position: absolute;
            display: inline-block;
            line-height: 1;
            vertical-align: middle;
            margin-left: -12px;
            margin-top: -10px;
            opacity: 0.8;
          }

          .logo {
            height: 60px;
            vertical-align: top;
            margin-right: 16px;
            border-style: none;
            margin-top: 2px;
          }

          .title {
            font-size: 40px;
            color: #000000;
            font-family: "Chinese Quote", -apple-system, BlinkMacSystemFont, "Segoe UI", "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "Helvetica Neue", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
            font-weight: bold;
            position: relative;
            top:-3px;
          }
        }
        .desc {
          font-size: 15px;
          color: rgba(0, 0, 0, 0.45);
          margin-top: 12px;
          margin-bottom: 50px;
        }
      }

      .main {
        min-width: 260px;
        width: 1200px;
        margin: 0 auto;
      }

      .footer {
        position: absolute;
        width: 100%;
        bottom: 0;
        text-align: center;
        //background: #FFFFFF;
        line-height: 50px;

        .links {
          margin-bottom: 8px;
          font-size: 14px;
          a {
            color: rgba(0, 0, 0, 0.45);
            transition: all 0.3s;
            &:not(:last-child) {
              margin-right: 40px;
            }
          }
        }
        .copyright {
          color: #000000;
          font-size: 14px;
        }
      }
    }
  }
</style>